import type React from 'react';
import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { LEAD_BASED_PAINT } from '../../../constants';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function LeadBasedPaintHazards_v1({ section, setSectionValues }: Props): JSX.Element {
  function onLeadPaintOnPropertyYesClick(): void {
    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.HAS_ON_PROPERTY]: true,
    });
  }

  function onLeadPaintOnPropertyNoClick(): void {
    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.HAS_ON_PROPERTY]: false,
    });
  }

  function onRelatedReportsYesClick(): void {
    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.HAS_RELATED_REPORTS]: true,
    });
  }

  function onRelatedReportsNoClick(): void {
    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.HAS_RELATED_REPORTS]: false,
    });
  }

  function onDescriptionChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  function onApplicableChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [LEAD_BASED_PAINT.FIELD_NAME.REPORTS_DESCRIPTION]: value,
    });
  }

  const leadPaintOnProperty = section.getFieldValue(LEAD_BASED_PAINT.FIELD_NAME.HAS_ON_PROPERTY);
  const relatedReports = section.getFieldValue(LEAD_BASED_PAINT.FIELD_NAME.HAS_RELATED_REPORTS);

  return (
    <FormField
      required
      label={<Label>Do you know of any lead-based paint on the property?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onLeadPaintOnPropertyYesClick}
          noHandler={onLeadPaintOnPropertyNoClick}
          yesActive={leadPaintOnProperty}
        >
          <>
            <FormField
              required
              css={{ marginBottom: 'layout.tight' }}
              label={<Label>Describe where on the property</Label>}
              control={
                <Textarea
                  onChange={onDescriptionChange}
                  value={section.getFieldValue(LEAD_BASED_PAINT.FIELD_NAME.DESCRIPTION)}
                  css={{ resize: 'vertical' }}
                />
              }
            />
            <FormField
              required
              label={<Label>Do you know of any reports related to the property and lead-based paint?</Label>}
              control={
                <YesAndNoExpansion
                  yesHandler={onRelatedReportsYesClick}
                  noHandler={onRelatedReportsNoClick}
                  yesActive={relatedReports}
                >
                  <FormField
                    required
                    label={<Label>List all applicable document names</Label>}
                    control={
                      <Textarea
                        onChange={onApplicableChange}
                        value={section.getFieldValue(LEAD_BASED_PAINT.FIELD_NAME.REPORTS_DESCRIPTION)}
                        css={{ resize: 'vertical' }}
                      />
                    }
                    description={
                      <FormHelp>
                        You must provide copies of the reports when you give the lease to your tenants
                      </FormHelp>
                    }
                  />
                </YesAndNoExpansion>
              }
            />
          </>
        </YesAndNoExpansion>
      }
    />
  );
}
